import React from 'react';
import SharedRootStore from './SharedRootStore';

export const sharedRootStoreInstance = new SharedRootStore();
export const appStoresContext = React.createContext(sharedRootStoreInstance);
export const useSharedStores = (): SharedRootStore => React.useContext(appStoresContext);
